import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可在此处添加token等请求头
    // config.headers['Authorization'] = getToken()
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 根据业务状态码处理
    if (res.code !== 0) {
      Message.error(res.message || 'Error')
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    console.log('err' + error)
    Message.error(error.message || '请求失败')
    return Promise.reject(error)
  }
)

// 封装请求方法
const http = {
  get(url, params) {
    return service({
      method: 'get',
      url,
      params,
      timeout: 10000
    })
  },
  
  post(url, data) {
    return service({
      method: 'post',
      url,
      data,
      timeout: 10000
    })
  },
  
  put(url, data) {
    return service({
      method: 'put',
      url,
      data,
      timeout: 10000
    })
  },
  
  delete(url, params) {
    return service({
      method: 'delete',
      url,
      params,
      timeout: 10000
    })
  },
  
  upload(url, file) {
    const formData = new FormData()
    formData.append('file', file)
    return service({
      method: 'post',
      url,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default http
